const neck_questions = [   
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"radio",
      "telehealth":"form1[0].#subform[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"form1[0].#subform[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"ROM Measurements After Repetitive Use Testing",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "3",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "questions":[
         {
            "main":"Forward Flexion",
            "subMain":"Normal Endpoint is 45 Degrees",
            "sub":"Post-Test ROM Measurement",
            "video": "/imgs/app/rom-videos/neck/Neck_Fwd_Flexion.mp4",            
            "type":"select",
            "dbqName":"form1[0].#subform[5].ROM1b3b[0]",
            "defaultVal":"45",
            "values":[
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"45"
         },
         {
            "main":"Right Lateral Flexion",
            "subMain":"Normal Endpoint is 45 Degrees",
            "sub":"Post-Test ROM Measurement",
            "video": "/imgs/app/rom-videos/neck/Neck_R_Lat_Flexion.mp4",            
            "type":"select",
            "dbqName":"form1[0].#subform[5].ROM3b3b[0]",
            "defaultVal":"45",
            "values":[
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"45"
         },
         {
            "main":"Right Lateral Rotation",
            "subMain":"Normal Endpoint is 80 Degrees",
            "sub":"Post-Test ROM Measurement",
            "video": "/imgs/app/rom-videos/neck/Neck_R_Lat_Rotation.mp4",            
            "type":"select",
            "dbqName":"form1[0].#subform[5].ROM5b3b[0]",
            "defaultVal":"80",
            "values":[
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"80"
         },
         {
            "main":"Extension",
            "subMain":"Normal Endpoint is 45 Degrees",
            "sub":"Post-Test ROM Measurement",
            "video": "/imgs/app/rom-videos/neck/Neck_Fwd_Extension.mp4",            
            "type":"select",
            "dbqName":"form1[0].#subform[5].ROM2b3b[0]",
            "defaultVal":"45",
            "values":[
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"45"
         },
         {
            "main":"Left Lateral Flexion",
            "subMain":"Normal Endpoint is 45 Degrees",
            "sub":"Post-Test ROM Measurement",
            "video": "/imgs/app/rom-videos/neck/Neck_L_Lat_Flexion.mp4",            
            "type":"select",
            "dbqName":"form1[0].#subform[5].ROM4b3b[0]",
            "defaultVal":"45",
            "values":[
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"45"
         },
         {
            "main":"Left Lateral Rotation",
            "subMain":"Normal Endpoint is 80 Degrees",
            "sub":"Post-Test ROM Measurement",
            "video": "/imgs/app/rom-videos/neck/Neck_L_Lat_Rotation.mp4",            
            "type":"select",
            "dbqName":"form1[0].#subform[5].ROM6b3b[0]",
            "defaultVal":"80",
            "values":[
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"80"
         }
      ]
   },
   {
      "question":"Which ROM exhibited pain? ",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "questions":[
         {
            "main":"Forward Flexion",
            "dbqName":"form1[0].#subform[6].Right_DorsiflexionPain3b[0]",
            "answer":""
         },
         {
            "main":"Right Lateral Flexion",
            "dbqName":"form1[0].#subform[6].Right_ExternalPain3b[0]",
            "answer":""
         },
         {
            "main":"Right Lateral Rotation",
            "dbqName":"form1[0].#subform[6].Right_ExternalRotation3b[0]",
            "answer":""
         },
         {
            "main":"Extension",
            "dbqName":"form1[0].#subform[6].Right_PlantarPain3b[0]",
            "answer":""
         },
         {
            "main":"Left Lateral Flexion",
            "dbqName":"form1[0].#subform[6].Right_InternalPain3b[0]",
            "answer":""
         },
         {
            "main":"Left Lateral Rotation",
            "dbqName":"form1[0].#subform[6].Right_InternalRotation3b[0]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain?",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 3,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "questions":[
               {
                  "main":"Weight-bearing",
                  "dbqName":"form1[0].#subform[7].Weightbearing3b[0],form1[0].#subform[7].YesNo133c4[1]",
                  "answer":""
               },
               {
                  "main":"Non-weight bearing",
                  "dbqName":"form1[0].#subform[7].Non-weightbearing3b[0],form1[0].#subform[7].YesNo133c4[1]",
                  "answer":""
               },
               {
                  "main":"Active motion",
                  "dbqName":"form1[0].#subform[7].Activemotion3b[0],form1[0].#subform[7].YesNo133c4[1]",
                  "answer":""
               },
               {
                  "main":"Passive motion",
                  "dbqName":"form1[0].#subform[7].Passivemotion3b[0],form1[0].#subform[7].YesNo133c4[1]",
                  "answer":""
               },
               {
                  "main":"On Rest/Non-movement",
                  "dbqName":"form1[0].#subform[7].Onrestnon-movement3b[0],form1[0].#subform[7].YesNo133c4[1]",
                  "answer":""
               },
               {
                  "main":"Causes functional loss",
                  "dbqName":"form1[0].#subform[7].Doesnot[0],form1[0].#subform[7].YesNo133c4[1]",
                  "answer":"",
                  "textarea": true,
                  "maxLength":620,
                  "textdbqName" : "form1[0].#subform[7].ExplainWhy3a44[0]",
                  "placeholder": "describe in the functional loss",
                  "textAnswer": ""
               },
               {
                  "main":"Does not result in/cause functional loss",
                  "dbqName":"form1[0].#subform[7].Causes[0],form1[0].#subform[7].YesNo133c4[1]",
                  "answer":""
               },
               {
                  "main":"None",
                  "partialField": true,
                  "dbqName":"form1[0].#subform[7].YesNo133c4[0]",
                  "answer":""
               }            
            ],
            "answer":""
   },
   {
      "question":"Is there objective evidence of crepitus?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATIONS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[7].YesNo133c[1]",
      "dbqName_no":"form1[0].#subform[7].YesNo133c[0]",
      "answer":"",
   },
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "presidence":"Yes",
      "maxLength":620,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[7].YesNo103a2[1]",
      "dbqName_no":"form1[0].#subform[7].YesNo103a2[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe location, severity, and relationship to condition(s)",
      "textdbqName":"form1[0].#subform[7].ExplainWhy3a4[0]",
      "textanswer":""
   },
   {
      "question":"Does ##name## have localized tenderness, guarding or muscle spasm of the thoracolumbar spine?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "7",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3E"
      },
      "presidence":"Yes",
      "ref":3,
      "dbqName_yes":"form1[0].#subform[9].Guarding_Spasms3g[1]",
      "dbqName_no":"form1[0].#subform[9].Guarding_Spasms3g[0]",
      "answer":"",
   },   
   {
   "question":"Localized tenderness",
   "sub":"",
   "type":"radioTiles",
   "multi": false,
   "show": false,
   "small": true,
   "refId":1,
   "cols": 2,
   "section": {
      page: "7",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "3E"
   },
   "questions":[
            {
               "main":"None",
               "dbqName":"form1[0].#subform[9].Tenderness3E[0]",
               "answer":""
            },
            {
               "main":"Not resulting in abnormal gait",
               "dbqName":"form1[0].#subform[9].Tenderness3E[1]",
               "answer":"",
               "textarea": true,
               "maxLength":690,
               "textdbqName" : "form1[0].#subform[9].DescribeTenderness3g1[0]",
               "placeholder": "Provide description and/or etiology",
               "textAnswer": ""
            }          
         ],
         "answer":""
   },
   {
      "question":"If ##name## has ##redHeading## of the thoracolumbar spine, identify which (choose only one)",
      "redHeading":"muscle spasms",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "small": true,
      "refId":2,
      "cols": 2,
      "section": {
         page: "7",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3E"
      },
      "questions":[
            {
               "main":"None",
               "dbqName":"form1[0].#subform[9].Spasm3g[0]",
               "answer":""
            },
            {
               "main":"Resulting in abnormal gait or abnormal spine contour",
               "dbqName":"form1[0].#subform[9].Spasm3g[1]",
               "answer":"",
               "textarea": true,
               "maxLength":688,
               "textdbqName" : "form1[0].#subform[9].DescribeSpasm3g2[0]",
               "placeholder": "Provide description and/or etiology",
               "textAnswer": ""
            },
            {
               "main":"Not resulting in abnormal gait or abnormal spinal contour",
               "dbqName":"form1[0].#subform[9].Spasm3g[2]",
               "answer":"",
               "textarea": true,
               "maxLength":688,
               "textdbqName" : "form1[0].#subform[9].DescribeSpasm3g2[0]",
               "placeholder": "Provide description and/or etiology",
               "textAnswer": ""
            },
            {
               "main":"Unable to evaluate, describe below",
               "dbqName":"form1[0].#subform[9].Spasm3g[3]",
               "answer":"",
               "textarea": true,
               "maxLength":688,
               "textdbqName" : "form1[0].#subform[9].DescribeSpasm3g2[0]",
               "placeholder": "Provide description and/or etiology",
               "textAnswer": ""
            }          
         ],
         "answer":""
   },
   {
      "question":"If ##name## has ##redHeading## of the thoracolumbar spine, identify which (choose only one)",
      "redHeading":"guarding",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "small": true,
      "refId":3,
      "cols": 2,
      "section": {
         page: "7",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3E"
      },
      "questions":[
         {
            "main":"None",
            "dbqName":"form1[0].#subform[9].Guarding3g[0]",
            "answer":""
         },
         {
            "main":"Resulting in abnormal gait or abnormal spine contour",
            "dbqName":"form1[0].#subform[9].Guarding3g[1]",
            "answer":"",
            "textarea": true,
            "maxLength":688,
            "textdbqName" : "form1[0].#subform[9].DescribeGuarding3g3[0]",
            "placeholder": "Provide description and/or etiology",
            "textAnswer": ""
         },
         {
            "main":"Not resulting in abnormal gait or abnormal spinal contour",
            "dbqName":"form1[0].#subform[9].Guarding3g[2]",
            "answer":"",
            "textarea": true,
            "maxLength":688,
            "textdbqName" : "form1[0].#subform[9].DescribeGuarding3g3[0]",
            "placeholder": "Provide description and/or etiology",
            "textAnswer": ""
         },
         {
            "main":"Unable to evaluate, describe below",
            "dbqName":"form1[0].#subform[9].Guarding3g[3]",
            "answer":"",
            "textarea": true,
            "maxLength":688,
            "textdbqName" : "form1[0].#subform[9].DescribeGuarding3g3[0]",
            "placeholder": "Provide description and/or etiology",
            "textAnswer": ""
         }          
      ],
      "answer":""
   },
   {
      "question":"Rate Muscle Strength",
      "redHeading": "Right Side",
      "sub":"RATE STRENGTH ACCORDING TO THE FOLLOWING SCALE",
      "type":"select",
      "show": true,
      "section": {
         page: "8",
         title: "MUSCLE STRENGTH TESTING",
         number: "4A"
      },
      "questions":[
         {
            "label":"Flexion/Extension",
            "title":"Right Side",
            "subMain":"Rate Strength",
            "sub":"",
            "options":[
               {
                  "main":"Elbow Flexion",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength1[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Elbow Extension",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength2[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Wrist Flexion",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength3[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Wrist Extension",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength4[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Finger Flexion",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength5[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Finger Abduction",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength6[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               }
            ]
         },
         {
            "label":"Flexion/Extension",
            "title":"Left Side",
            "subMain":"Rate Strength",
            "sub":"",
            "options":[
               {
                  "main":"Elbow Flexion",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Left_Strength1[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Elbow Extension",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Left_Strength2[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Wrist Flexion",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Left_Strength3[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Wrist Extension",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Left_Strength4[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Finger Flexion",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Left_Strength5[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Finger Abduction",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Left_Strength6[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               }
            ]
         }
      ],
      "rules": [
       {
         "label":"Muscle Strength-Rate Scale",
         "legend":"muscleStrengthScale",
         "title":".",
         "subMain":"",
         "sub":"",
         "options":[
            {
              "main":"No Muscle Movement",
              "sub":"0/5"
            },
            {
              "main":"Palpable or visible muscle contraction, but no joint movement",
              "sub":"1/5"
            },
            {
              "main":"Active Movement with Gravity Eliminated",
              "sub":"2/5"
            },
            {
              "main":"Active Movement Against Gravity",
              "sub":"3/5"
            },
            {
              "main":"Active Movement Against Some Resistance",
              "sub":"4/5"
            },
            {
              "main":"Normal Strength",
              "sub":"5/5"
            }
         ]
       }
      ]
   },   
   {
      "question":"Rate Deep Tendon Reflexes",
      "redHeading": "Right Side",
      "sub":"RATE DEEP TENDON REFLEXES (DTRs) ACCORDING TO THE FOLLOWING SCALE",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "REFLEX EXAM",
         number: "5A"
      },
      "questions":[
         {
            "label":"Right Bicep",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "2+ Normal",
            "options":[
               {
                  "main":"0 Absent",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Bicep[0]",
                  "sub":""
               },
               {
                  "main":"1+ Hypoactive",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Bicep[0]",
                  "sub":""
               },
               {
                  "main":"2+ Normal",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Bicep[0]",
                  "sub":""
               },
               {
                  "main":"3+ Hyperactive without Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Bicep[0]",
                  "sub":""
               },
               {
                  "main":"4+ Hyperactive with Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Bicep[0]",
                  "sub":""
               }
            ],
            "answer":"2+ Normal"
         },
         {
            "label":"Right Tricep",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "2+ Normal",
            "options":[
               {
                  "main":"0 Absent",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Tricep[0]",
                  "sub":""
               },
               {
                  "main":"1+ Hypoactive",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Tricep[0]",
                  "sub":""
               },
               {
                  "main":"2+ Normal",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Tricep[0]",
                  "sub":""
               },
               {
                  "main":"3+ Hyperactive without Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Tricep[0]",
                  "sub":""
               },
               {
                  "main":"4+ Hyperactive with Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Tricep[0]",
                  "sub":""
               }
            ],
            "answer":"2+ Normal"
         },
         {
            "label":"Right Brachioradialis",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "2+ Normal",
            "options":[
               {
                  "main":"0 Absent",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Brachoradialis[0]",
                  "sub":""
               },
               {
                  "main":"1+ Hypoactive",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Brachoradialis[0]",
                  "sub":""
               },
               {
                  "main":"2+ Normal",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Brachoradialis[0]",
                  "sub":""
               },
               {
                  "main":"3+ Hyperactive without Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Brachoradialis[0]",
                  "sub":""
               },
               {
                  "main":"4+ Hyperactive with Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Brachoradialis[0]",
                  "sub":""
               }
            ],
            "answer":"2+ Normal"
         }
      ]
   },
   {
      "question":"Rate Deep Tendon Reflexes",
      "redHeading": "Left Side",
      "sub":"RATE DEEP TENDON REFLEXES (DTRs) ACCORDING TO THE FOLLOWING SCALE",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "REFLEX EXAM",
         number: "5A"
      },
      "questions":[
         {
            "label":"Left Bicep",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "2+ Normal",
            "options":[
               {
                  "main":"0 Absent",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Bicep[0]",
                  "sub":""
               },
               {
                  "main":"1+ Hypoactive",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Bicep[0]",
                  "sub":""
               },
               {
                  "main":"2+ Normal",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Bicep[0]",
                  "sub":""
               },
               {
                  "main":"3+ Hyperactive without Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Bicep[0]",
                  "sub":""
               },
               {
                  "main":"4+ Hyperactive with Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Bicep[0]",
                  "sub":""
               }
            ],
            "answer":"2+ Normal"
         },
         {
            "label":"Left Tricep",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "2+ Normal",
            "options":[
               {
                  "main":"0 Absent",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Tricep[0]",
                  "sub":""
               },
               {
                  "main":"1+ Hypoactive",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Tricep[0]",
                  "sub":""
               },
               {
                  "main":"2+ Normal",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Tricep[0]",
                  "sub":""
               },
               {
                  "main":"3+ Hyperactive without Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Tricep[0]",
                  "sub":""
               },
               {
                  "main":"4+ Hyperactive with Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Tricep[0]",
                  "sub":""
               }
            ],
            "answer":"2+ Normal"
         },
         {
            "label":"Left Brachioradialis",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "2+ Normal",
            "options":[
               {
                  "main":"0 Absent",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Brachoradialis[0]",
                  "sub":""
               },
               {
                  "main":"1+ Hypoactive",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Brachoradialis[0]",
                  "sub":""
               },
               {
                  "main":"2+ Normal",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Brachoradialis[0]",
                  "sub":""
               },
               {
                  "main":"3+ Hyperactive without Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Brachoradialis[0]",
                  "sub":""
               },
               {
                  "main":"4+ Hyperactive with Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Brachoradialis[0]",
                  "sub":""
               }
            ],
            "answer":"2+ Normal"
         }
      ]
   },
   {
      "question":"Sensory Exam",
      "redHeading": "Right Side",
      "sub":" RESULTS FOR SENSATION TO LIGHT TOUCH (dermatome) TESTING",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "SENSORY EXAM",
         number: "6A"
      },
      "questions":[
         {
            "label":"Shoulder Area (C5)",
            "title":"Right Side",
            "subMain":"",
            "sub":"C5",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Right_UpperThigh[2]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Right_UpperThigh[0]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Right_UpperThigh[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Inner/Outer Forearm (C6/T1)",
            "title":"Right Side",
            "subMain":"",
            "sub":"C6/T1",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Right_Thigh[0]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Right_Thigh[2]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Right_Thigh[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Hand/Fingers (C6-8)",
            "title":"Right Side",
            "subMain":"",
            "sub":"C6-8",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Right_LowerLeg[2]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Right_LowerLeg[0]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Right_LowerLeg[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         }
      ]
   },
   {
      "question":"Sensory Exam",
      "redHeading": "Left Side",
      "sub":" RESULTS FOR SENSATION TO LIGHT TOUCH (dermatome) TESTING",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "SENSORY EXAM",
         number: "6A"
      },
      "questions":[
         {
            "label":"Shoulder Area (C5)",
            "title":"Left Side",
            "subMain":"",
            "sub":"C5",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Left_UpperThigh[0]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Left_UpperThigh[2]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Left_UpperThigh[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Inner/Outer Forearm (C6/T1)",
            "title":"Left Side",
            "subMain":"",
            "sub":"C6/T1",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Left_Thigh[2]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Left_Thigh[0]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Left_Thigh[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Hand/Fingers (C6-8)",
            "title":"Left Side",
            "subMain":"",
            "sub":"C6-C8",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Left_LowerLeg[0]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Left_LowerLeg[2]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Left_LowerLeg[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         }
      ]
   },
   {
      "question":"Does ##name## have radicular pain or any other signs or symptoms due to radiculopathy?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "9",
         title: "RADICULOPATHY",
         number: "7A"
      },
      "presidence":"Yes",
      "ref":2,
      "dbqName_yes":"form1[0].#subform[11].YesNo117a[0]",
      "dbqName_no":"form1[0].#subform[11].YesNo117a[1]",
      "answer":"",
   },
   {
      "question":"Radiculopathy for ##redHeading##",
      "redHeading":"Right Side",
      "sub":"Evaluate severity of radiculopathy by incorporating the effects of subjective symptoms (e.g ##name## indicates numbness, tingling, etc.) and objective findings",
      "type":"radio",
      "show": false,
      "refId":1,
      "section": {
         page: "9",
         title: "RADICULOPATHY",
         number: "7A"
      },
      "questions":[
         {
            "label":"Constant pain",
            "title":"Right Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[11].Right_Severity1[2]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[11].Right_Severity1[1]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[11].Right_Severity1[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[11].Right_Severity1[3]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Intermittent pain",
            "title":"Right Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[11].Right_Severity2[1]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[11].Right_Severity2[2]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[11].Right_Severity2[3]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[11].Right_Severity2[0]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Paresthesias and/or dysesthesias",
            "title":"Right Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[11].Right_Severity4[2]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[11].Right_Severity4[1]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[11].Right_Severity4[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[11].Right_Severity4[3]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Numbness",
            "title":"Right Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[11].Right_Severity5[1]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[11].Right_Severity5[2]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[11].Right_Severity5[3]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[11].Right_Severity5[0]",
                  "sub":""
               }
            ],
            "answer":"None"
         }
      ]
   },
   {
      "question":"Radiculopathy for ##redHeading##",
      "redHeading":"Left Side",
      "sub":"Evaluate severity of radiculopathy by incorporating the effects of subjective symptoms (e.g ##name## indicates numbness, tingling, etc.) and objective findings",
      "type":"radio",
      "show": false,
      "refId":2,
      "section": {
         page: "9",
         title: "RADICULOPATHY",
         number: "7A"
      },
      "questions":[
         {
            "label":"Constant pain",
            "title":"Left Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[11].Left_Severity1[1]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[11].Left_Severity1[2]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[11].Left_Severity1[3]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[11].Left_Severity1[0]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Intermittent Pain",
            "title":"Left Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[11].Left_Severity2[2]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[11].Left_Severity2[1]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[11].Left_Severity2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[11].Left_Severity2[3]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Paresthesias and/or dysesthesias",
            "title":"Left Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[11].Left_Severity4[1]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[11].Left_Severity4[2]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[11].Left_Severity4[3]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[11].Left_Severity4[0]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Numbness",
            "title":"Left Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[11].Left_Severity5[2]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[11].Left_Severity5[1]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[11].Left_Severity5[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[11].Left_Severity5[3]",
                  "sub":""
               }
            ],
            "answer":"None"
         }
      ]
   },
   {
      "question":"Does ##name## have any other signs or symptoms of radiculopathy?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "9",
         title: "RADICULOPATHY",
         number: "7B"
      },
      "presidence":"Yes",
      "maxLength":445,
      "ref":1,
      "dbqName_yes":"form1[0].#subform[11].YesNo12[1]",
      "dbqName_no":"form1[0].#subform[11].YesNo12[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe about the symptoms",
      "textdbqName":"form1[0].#subform[11].Comments[0]",
      "textanswer":""
   },
   {
      "question":"Indicate nerve roots involved",
      "sub":"Indicate sides affected",
      "type":"radio",
      "show": false,
      "refId":1,
      "multi": true,
      "section": {
         page: "10",
         title: "RADICULOPATHY",
         number: "7C"
      },
      "questions":[
         {
            "label":"Involvement of C5/C6 nerve roots (upper radicular group)",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"Right",
                  "dbqName":"form1[0].#subform[12].NerveRoots[0],form1[0].#subform[12].SideAffected14[1]",
                  "sub":""
               },
               {
                  "main":"Left",
                  "dbqName":"form1[0].#subform[12].NerveRoots[0],form1[0].#subform[12].SideAffected14[0]",
                  "sub":""
               },
               {
                  "main":"Both",
                  "dbqName":"form1[0].#subform[12].NerveRoots[0],form1[0].#subform[12].SideAffected14[2]",
                  "sub":""
               },
               {
                  "main":"None",
                  "dbqName":"pass_this_question",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Involvement of C7 nerve roots (middle radicular group)",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"Right",
                  "dbqName":"form1[0].#subform[12].NerveRoots[2],form1[0].#subform[12].SideAffected15[1]",
                  "sub":""
               },
               {
                  "main":"Left",
                  "dbqName":"form1[0].#subform[12].NerveRoots[2],form1[0].#subform[12].SideAffected15[2]",
                  "sub":""
               },
               {
                  "main":"Both",
                  "dbqName":"form1[0].#subform[12].NerveRoots[2],form1[0].#subform[12].SideAffected15[0]",
                  "sub":""
               },
               {
                  "main":"None",
                  "dbqName":"pass_this_question",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Involvement of C8/T1 nerve roots (lower radicular group)",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"Right",
                  "dbqName":"form1[0].#subform[12].NerveRoots[1],form1[0].#subform[12].SideAffected16[1]",
                  "sub":""
               },
               {
                  "main":"Left",
                  "dbqName":"form1[0].#subform[12].NerveRoots[1],form1[0].#subform[12].SideAffected16[0]",
                  "sub":""
               },
               {
                  "main":"Both",
                  "dbqName":"form1[0].#subform[12].NerveRoots[1],form1[0].#subform[12].SideAffected16[2]",
                  "sub":""
               },
               {
                  "main":"None",
                  "dbqName":"pass_this_question",
                  "sub":""
               }
            ],
            "answer":"None"
         }
      ]
   },
   {
      "question":"Additional Comments",
      "sub":"",
      "show": true,
      "section": {
         page: "13",
         title: "REMARKS",
         number: "16A"
      },
      "optional": true,
      "maxLength":445,
      "type":"textarea",
      "options":[],
      "dbqName":"form1[0].#subform[15].Comments16[0]",
      "answer":""
   }
]

export default neck_questions;